import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-md-6 offset-0 offset-md-3" }
const _hoisted_3 = { class: "card card-flush" }
const _hoisted_4 = { class: "card-header pt-7" }
const _hoisted_5 = { class: "card-title align-items-start flex-column" }
const _hoisted_6 = { class: "card-label fw-bolder fs-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1 fw-bold fs-6" }, "Let's get you set up", -1)
const _hoisted_8 = { class: "card-toolbar" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-4 d-none d-md-inline" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "symbol-label bg-light-primary" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-building fa-2x text-white" })
  ])
], -1)
const _hoisted_12 = { class: "me-2" }
const _hoisted_13 = { class: "text-white fs-4 fw-bolder" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-inline fw-bolder d-block fs-7" }, "upload a photo and add some basic information about your organization", -1)
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle fa-3x text-success" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-do-not-enter fa-3x text-primary" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right" }, null, -1)
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-4 d-none d-md-inline" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "symbol-label bg-light-primary" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-masks-theater fa-2x text-white" })
  ])
], -1)
const _hoisted_25 = { class: "me-2" }
const _hoisted_26 = { class: "text-white fs-4 fw-bolder" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-inline fw-bolder d-block fs-7" }, "add rehearsal spaces, custom groups, and invite your cast & crew", -1)
const _hoisted_28 = { class: "d-flex align-items-center" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle fa-3x text-success" }, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-do-not-enter fa-3x text-primary" }, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center flex-grow-1 me-2 me-sm-5\"><div class=\"symbol symbol-50px me-4 d-none d-md-inline\"><span class=\"symbol-label bg-light-primary\"><i class=\"fa fa-address-card fa-2x text-white\"></i></span></div><div class=\"me-2\"><div class=\"text-white fs-4 fw-bolder\">Finish Your Personal Profile</div><span class=\"d-none d-md-inline fw-bolder d-block fs-7\">upload your profile photo, and add your emergency contacts</span></div></div>", 1)
const _hoisted_37 = { class: "d-flex align-items-center" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle fa-3x text-success" }, null, -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { key: 1 }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-do-not-enter fa-3x text-primary" }, null, -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right" }, null, -1)
const _hoisted_45 = { class: "d-flex flex-column align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, "Welcome, " + _toDisplayString(_ctx.userStore.profile.firstName) + "!", 1),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Button, {
              type: "secondary",
              onClick: _ctx.navigateToUserHome,
              class: "d-none d-md-block"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Skip for now")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organizations, (organization) => {
            return (_openBlock(), _createElementBlock("div", {
              key: organization.organizationId,
              class: "d-flex border border-gray-300 border-dashed rounded p-6 mb-6 cursor-pointer"
            }, [
              _createElementVNode("div", {
                onClick: ($event: any) => (_ctx.navigateToOrganizationOnboarding(organization.organizationId)),
                class: "d-flex align-items-center flex-grow-1 me-2 me-sm-5"
              }, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, "Set up " + _toDisplayString(organization.name), 1),
                  _hoisted_14
                ])
              ], 8, _hoisted_10),
              _createElementVNode("div", _hoisted_15, [
                (_ctx.orgStatus === 'completed')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                  : _createCommentVNode("", true),
                (_ctx.orgStatus === 'skip')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                  : _createCommentVNode("", true),
                (_ctx.orgStatus === 'open')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      onClick: ($event: any) => (_ctx.navigateToOrganizationOnboarding(organization.organizationId)),
                      type: "primary",
                      class: "btn-icon"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_22
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productions, (production) => {
            return (_openBlock(), _createElementBlock("div", {
              key: production.productionId,
              class: "d-flex border border-gray-300 border-dashed rounded p-6 mb-6 cursor-pointer"
            }, [
              _createElementVNode("div", {
                onClick: ($event: any) => (_ctx.navigateToProductionOnboarding(production.productionId)),
                class: "d-flex align-items-center flex-grow-1 me-2 me-sm-5"
              }, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, "Set up " + _toDisplayString(production.name), 1),
                  _hoisted_27
                ])
              ], 8, _hoisted_23),
              _createElementVNode("div", _hoisted_28, [
                (_ctx.prodStatus === 'completed')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
                  : _createCommentVNode("", true),
                (_ctx.prodStatus === 'skip')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
                  : _createCommentVNode("", true),
                (_ctx.prodStatus === 'open')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      onClick: ($event: any) => (_ctx.navigateToProductionOnboarding(production.productionId)),
                      type: "primary",
                      class: "btn-icon"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_35
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128)),
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateToUserOnboarding && _ctx.navigateToUserOnboarding(...args))),
            class: "d-flex border border-gray-300 border-dashed rounded p-6 mb-6 cursor-pointer"
          }, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              (_ctx.userStatus === 'completed')
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
                : _createCommentVNode("", true),
              (_ctx.userStatus === 'skip')
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_43))
                : _createCommentVNode("", true),
              (_ctx.userStatus === 'open')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 2,
                    type: "primary",
                    class: "btn-icon"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_44
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_Button, {
              type: "secondary",
              class: "d-block d-md-none mb-4",
              onClick: _ctx.navigateToUserHome
            }, {
              default: _withCtx(() => [
                _createTextVNode("skip for now ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ])
    ])
  ]))
}